export default function getRoles(response) {
  const data = response.data.response.map((item) => {
    return {
      value: item.id,
      label: item.name,
    };
  });

  return data;
}
